import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useState } from 'react';
import { GrFormSubtract } from "react-icons/gr";
import { IoIosAdd } from "react-icons/io";
import CreateTask from './createTask';

function SelectedModel({ show, handleClose, handleConfirm }) {
  const [inputValue, setInputValue] = useState('');
  const [showCreateTaskModal, setShowCreateTaskModal] = useState(false);

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

 
  const handleShowCreateTaskModal = () => setShowCreateTaskModal(true);
  const handleCreateTaskClose = () => setShowCreateTaskModal(false);

  const inputStyling = {
    padding: '8px',
    fontSize: '1rem',
    border: '1px solid #ccc',
    borderRadius: '4px',
    outline: 'none',
    width: '275px',
    height: '300px',
    marginLeft: '80px',
  };
  const inputStyled = {
    padding: '8px',
    fontSize: '1rem',
    border: '1px solid #ccc',
    borderRadius: '4px',
    outline: 'none',
    width: '275px',
    height: '300px',
    marginRight:"120px"

  };

  const containerStyling = {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '20px', // Add space between the two sections if needed
  };
  

  return (
    <Modal show={show} onHide={handleClose} dialogClassName="modal-90w" centered size="lg">
      <Modal.Header closeButton style={{ backgroundColor: '#004aad' }}>
        <Modal.Title className='heading' style={{ color: 'white' }}>Select Procedure Tasks</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h5><b style={{ fontSize: "24px" }}>Select Procedure Tasks</b></h5>
        <br />
        <div style={containerStyling}>
          <div>
            <h5><b style={{ fontSize: "16px", marginLeft:"80px"}}>Procedure Tasks</b></h5>
            <div>
              <input
                type="text"
                value={inputValue}
                onChange={handleInputChange}
                style={inputStyling}
                placeholder=""
              />
            </div>
          </div>
          <div>
            <h5><b style={{ fontSize: "16px" }}>Available Tasks</b></h5>
            <div>
              <input
                type="text"
                value={inputValue}
                onChange={handleInputChange}
                style={inputStyled}
                placeholder=""
              />
            </div>
          </div>
        </div>
      </Modal.Body>
      <div style={{ position: 'relative', paddingBottom: '50px' }}>
        <Button
          variant="secondary"
          onClick={handleClose}
          style={{
            backgroundColor: '#004aad',
            borderColor: '#004aad',
            marginLeft:"90px"
          }}
        >
          <GrFormSubtract style={{marginRight:"5px"}}/>Clear Tasks
        </Button>
        <Button
          variant="secondary"
          onClick={handleShowCreateTaskModal}
          style={{
            backgroundColor: '#004aad',
            borderColor: '#004aad',
            position: 'absolute',
            right: '130px', // Adjust as needed to space the buttons
          }}
        >
          <IoIosAdd />Create Tasks 
        </Button>
        <CreateTask show={ showCreateTaskModal } handleClose={handleCreateTaskClose}/>
        <div>
          <br/>
        <Button
          variant="secondary"
          onClick={handleClose}
          style={{
            backgroundColor: '#004aad',
            borderColor: '#004aad',
            marginLeft:"430px"
          }}
        >
          Cancel
        </Button>
        <Button
          variant="secondary"
          onClick={handleClose}
          style={{
            backgroundColor: '#004aad',
            borderColor: '#004aad',
            position: 'absolute',
            right: '130px', // Adjust as needed to space the buttons
          }}
        >
          Reschedule Tasks
        </Button>
        </div>
      </div>
    </Modal>
  );
}

export default SelectedModel;
